import { render, staticRenderFns } from "./landTrustCard.vue?vue&type=template&id=04870de4&scoped=true"
import script from "./landTrustCard.vue?vue&type=script&lang=js"
export * from "./landTrustCard.vue?vue&type=script&lang=js"
import style0 from "./landTrustCard.vue?vue&type=style&index=0&id=04870de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04870de4",
  null
  
)

export default component.exports